module.exports = __webpack_public_path__ + "img/u30.72c0d5ab.svg";